// Locale-aware wrappers around static data files.
// Any component that consumes data should import from here instead of from `@/data/*`.
import { useLocalized } from "@/i18n/helpers";
import { BRANDS as _BRANDS, getBrand as _getBrand } from "./brands";
import { TRESORS as _TRESORS, getTresor as _getTresor } from "./tresors";
import { ARTICLES as _ARTICLES, getArticle as _getArticle } from "./articles";
import { BRAND_EDITORIAL as _EDITORIAL, getEditorial as _getEditorial } from "./brandEditorial";
import { getEditorialPlus as _getEditorialPlus } from "./brandEditorialPlus";
import { ACTUALITES as _ACTUALITES, IMPACT_STATS as _IMPACT_STATS } from "./content";

export const useBrands = () => useLocalized(_BRANDS);
export const useBrand = (slug) => useLocalized(_getBrand(slug));
export const useTresors = () => useLocalized(_TRESORS);
export const useTresor = (slug) => useLocalized(_getTresor(slug));
export const useArticles = () => {
 const list = useLocalized(_ARTICLES);
 return Array.isArray(list) ? list.filter((a) => !a.hidden) : list;
};
export const useArticle = (slug) => useLocalized(_getArticle(slug));
// Étape 5 — Fusion base editorial + enrichissement (rituals, terroirs, faq, programmes...)
export const useEditorial = (slug) => {
 const base = useLocalized(_getEditorial(slug));
 const plus = useLocalized(_getEditorialPlus(slug));
 if (!base && !plus) return null;
 return {...(base || {}),...(plus || {}) };
};
export const useActualites = () => useLocalized(_ACTUALITES);
export const useImpactStats = () => useLocalized(_IMPACT_STATS);
